import {Component, Inject} from 'ng-metadata/core';
import serviceProviders, {CitationTrailsBreadcrumbsService} from './citationTrailsBreadcrumbs.service';
import {Breadcrumbs} from '../../infra/dataStructures/collections/breadcrumbs/breadcrumbs.structure';
import {HttpService} from '../../infra/httpRequest/http.service';
import {SearchFieldsService} from '../search.fields.service';
import {getInstitutionCode, getVid, getBackendSystem} from '../../appConfig/appConfigForward';
import {IState} from 'angular-ui-router';
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {PrimoResponse} from '../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {MediaQueries} from '../../infra/mediaQueries.service';
import {ChangeLangService} from '../../infra/lang/changeLang.service';
import {ALERT_MSG_TYPE,AlertFactory} from "../../infra/widgets/alerts/alertFactory.service";
import {IAlertMsg} from '../../infra/widgets/alerts/alertMsg.interface';
import {PagesTitlesService} from "../../infra/accessibility/pagesTitles.service";


//your imports go here

const _flatten = require('lodash/flatten');
const clone = require('lodash/clone');
const get = require('lodash/get');

@Component({
    providers: [].concat(serviceProviders), //put here all angular1 modules which this directive needs
    selector: 'prm-citation-trails-breadcrumbs',
    templateUrl: 'components/search/citationTrails/citation-trails-breadcrumbs.html',
})



export class PrmCitationTrailsBreadcrumbs {
    get citedByAlert() {
        return this._citedByAlert;
    }

    set citedByAlert(value) {
        this._citedByAlert = value;
    }
    set citingAlert(value) {
        this._citingAlert = value;
    }

    private showLeftArrow: boolean;
    private showRightArrow: boolean;
    private offseterElem: HTMLElement;
    private containerElem: HTMLElement;
    private SEARCH_STATE = STATE_NAMES.SEARCH;
    private savedSearchParams: Object;
    private hideArrows: boolean = false;
    private _citingAlert :IAlertMsg;
    private _citedByAlert :IAlertMsg;


    constructor(private ctBreadcrumbsService: CitationTrailsBreadcrumbsService,
                @Inject('$state') private $state: IState,
                private httpService: HttpService,
                private searchFieldsService: SearchFieldsService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private mediaQueries: MediaQueries,
                @Inject('restBaseURLs') private restBaseURLs,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$interval') private $interval: ng.IIntervalService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$location') private $location: ng.ILocationService,
                private changeLangService: ChangeLangService,
                private alertService:AlertFactory,
                private pagesTitlesService : PagesTitlesService) {
    	this._citingAlert = alertService.create(ALERT_MSG_TYPE.GENERAL);
        this._citingAlert.show('<span translate="citation_trail.title.citation.info"></span>');

        this._citedByAlert = alertService.create(ALERT_MSG_TYPE.GENERAL);
        this._citedByAlert.show('<span translate="citation_trail.title.cited_by.info"></span>');
        this.$timeout(()=> {
            this.fristPageLoadCitationTrails();
        }, 0);

        this.showLeftArrow = true;
        this.showRightArrow = true;
        this.offseterElem = angular.element(document.querySelector(".horizontal-content-scroller"))[0];
        this.containerElem = angular.element(document.querySelector(".horizontal-content-scroller"))[0];
        if (searchFieldsService.searchParams.query) {
            this.savedSearchParams = clone(searchFieldsService.searchParams);
        }
        else {
            this.savedSearchParams = {
                vid: this.$state.params.vid,
                query: this.$state.params.query,
                search_scope: this.$state.params.search_scope,
                tab: this.$state.params.tab
            };
        }
        if(this.savedSearchParams.query){
            if(Array.isArray(this.savedSearchParams.query)){
                this.savedSearchParams.query = this.savedSearchParams.query.map(q => q ? q.replace(/~2F/g, '/') : q);
            }
            else if(typeof this.savedSearchParams.query === 'string'){
                this.savedSearchParams.query = this.savedSearchParams.query.replace(/~2F/g, '/');
            }else{
                console.log('The query type could not be identified.');
            }        
        }
        this.$scope.$on('addCitationEvent', (event, data)=> {
            this.onAddCitationEvent(event, data)
        });

        this.updatePagesTitles();
    }

    private updatePagesTitles() {
        let searchQuery = this.searchFieldsService.mainSearch;
        let actionToCode = {
            'exploreMain.citationTrails': ['nui.citation_trail.link.header', '$$QUERY$$'],
        };

        let titles = {codes: actionToCode[this.$state.current.name], query: searchQuery};
        this.pagesTitlesService.updatePagesTitles(titles);
    }

    private ngOnInit() {
        this.updateCtSession();
        this.setActiveLevel(this.$state.params.active);
        this.refreshSeedsInfo(this.$state.params);   
    }

    private onAddCitationEvent(event: ng.IAngularEvent, data) {
//	    event.stopPropagation();  
        this.hideArrows = true; //this is done to prevent right or left arrow flickering when adding new citation
        this.$timeout(()=> {
            this.hideArrows = false;
        }, 200);
        let params = data.params;
        this.refreshSeedsInfo(params);
        this.ctBreadcrumbsService.performCitationTrailsSearch(params).then(()=> {
            this.fristPageLoadCitationTrails();
        });
        this.ctBreadcrumbsService.updateURLSearchParams(params);
    }
    
    private clearBackToSearchParams(){
        let citationTrailFilterByAvailabilityParamValue = this.$location.search().citationTrailFilterByAvailability;
        if (citationTrailFilterByAvailabilityParamValue){
            this.savedSearchParams.citationTrailFilterByAvailability = citationTrailFilterByAvailabilityParamValue;
        }
        delete this.savedSearchParams.facet;
    }

    get seedList() {
        return this.ctBreadcrumbsService.seeds.asList();
    }

    get citationTraisLength(){
        return this.seedList.length > 0
    }

    get activeSeedTypeCiting():boolean{
        return this.seedList[this.getActiveLevel()].citeType === "citing";

    }

    public getMdListClass($index) {
        return {
            'md-list-item-custom': ($index !== this.getActiveLevel()),
            'md-list-custom': $index === 0
        }
    }

    public onChangeActiveSeedEvent(seed: SeedData, level: number) {
        if (this.ctBreadcrumbsService.seeds.getActiveLevel() === level) { //if the clicked seed is already active do nothing
            return;
        }
        this.setActiveLevel(level);
        let params = this.$location.search();
        params.active = level;
        params.offset = 0;
        let facetType = seed.citeType;
        let frbrgroupid = seed.frbrGroupId;
        params.facet = facetType + ',exact,' + frbrgroupid;
        this.ctBreadcrumbsService.updateURLSearchParams(params);
        params.seedInfo = null;
        this.refreshSeedsInfo(params);
        this.ctBreadcrumbsService.performCitationTrailsSearch(params).then(()=> {
            this.fristPageLoadCitationTrails();
        });
    }

    private fristPageLoadCitationTrails() {
        this.$timeout(()=> {
            let pageElement = document.querySelector('#citationTrail') as HTMLElement;
            if (pageElement) {
                pageElement.setAttribute('tabindex', '-1');
                pageElement.focus();
                pageElement.setAttribute('tabindex', '0');
            }
        }, 0);

    }



    public getActiveLevel() {
        return this.ctBreadcrumbsService.seeds.getActiveLevel();
    }

    private updateCtSession() {
        let seeds = _flatten([this.$state.params.seed_id]);
        if (seeds.length === 1) {
            this.ctBreadcrumbsService.seeds = new Breadcrumbs<SeedData>();
        }
    }

    private refreshSeedsInfo(data) {
        let seedInfo = data.seedInfo;
        if (seedInfo) {
            let newSeedId = get(data,'seedInfo.recordId');
            let currBreadcrumbs = get(this,'ctBreadcrumbsService.seeds._crumbs');
            if ( currBreadcrumbs && (currBreadcrumbs.length === 0 || (data.came_from === 'citationTtrailsIndication' && newSeedId !== currBreadcrumbs[currBreadcrumbs.length - 1].recordId))){
                this.ctBreadcrumbsService.seeds.push(seedInfo);
                this.$location.search('came_from', null);
            }
        } else if (this.ctBreadcrumbsService.seeds.isEmpty()) {
            let params = {
                seeds: Array.isArray(data.seed_id) ? [data.seed_id][0].join('|,|') : data.seed_id,
                inst: getInstitutionCode(),
                lang: data.lang,
                adaptor: data.adaptor,
            };

            if (getBackendSystem()==='suprima') {
                params = {
                    seeds: Array.isArray(data.seed_id) ? [data.seed_id][0].join('|,|') : data.seed_id,
                    inst: getInstitutionCode(),
                    lang: data.lang,
                    adaptor: data.adaptor,
                    vid: getVid(),
                    search_scope: this.$state.params.search_scope,
                };
            }


            this.httpService.call('GET', this.restBaseURLs.citationTrailsSeedsInfo, params)
                .then((data)=> {
                    this.onSeedsInfoSuccess(data)
                });
        }

    }

    private setActiveLevel(activeLevel) {
        if (activeLevel !== undefined) {
            this.ctBreadcrumbsService.seeds.setActiveLevel(activeLevel);
        }
    }

    private onSeedsInfoSuccess(res) {
        //res = {"seedsInfo":[{"creator":["Mishra, Seema"],"pnxId":"TN_medline22208263","title":"Life?"},{"creator":["Di Mauro, E.","Saladino, R.","Trifonov, E.N."],"pnxId":"TN_scopus2-s2.0-84892969157","title":"The path to lifes origins. Remaining hurdles"}],"beaconO22":"1352"};
        let seedsInfo = res.seedsInfo;
        if (seedsInfo) {
            let seedsData = seedsInfo.map(s => new SeedData(s.citationType, s.title, s.creator.join('; '), s.frbrGroupId, s.pnxId));
            this.ctBreadcrumbsService.seeds = new Breadcrumbs<SeedData>(seedsData);

        }
        if (this.$state.params.active) {
            this.setActiveLevel(this.$state.params.active);
        }
    }

    private onLeftArrowClick() {
        this.smoothScrollClick('left', this.offseterElem);
    }

    private onRightArrowClick() {
        this.smoothScrollClick('right', this.offseterElem);
    }

    private isShowLeftArrow() {
        if (this.changeLangService.direction === 'rtl'){
            return this.offseterElem.scrollLeft > 50;
        }
        return this.offseterElem.scrollLeft > 0;
    };

    private isShowRightArrow() {
        return this.getScrollRight() > 0;
    };

    private getScrollRight() {
            let scrollRight = this.offseterElem.scrollWidth - this.offseterElem.scrollLeft - this.containerElem.offsetWidth;
            return (scrollRight < 15) ? 0 : scrollRight;
    }

    private easeInOutQuart(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t * t * t + b;
        t -= 2;
        return -c / 2 * (t * t * t * t - 2) + b;
    };

    private smoothScrollClick(direction: String, elem: HTMLElement) {
        let clickScrollDistance = 120;

        if (direction === 'left') {
            clickScrollDistance = -clickScrollDistance;
        }

        let frame = 0;
        let numOfFrames = 60;
        let beginningPos = elem.scrollLeft;

        let interval = this.$interval(() => {
            let newPos = this.easeInOutQuart(frame, beginningPos, clickScrollDistance, numOfFrames);
            frame++;
            elem.scrollLeft = newPos;
            if (frame === numOfFrames) {
                this.$interval.cancel(interval);
            }
        }, 2);
    }

    public isActive($index) {
        if ($index == this.ctBreadcrumbsService.seeds.getActiveLevel()) {
            return 'nui.aria.active_seed';
        }
        else {
            return ' ';
        }
    }

    get citingAlert(){
        return this._citingAlert;
    }


}


export class SeedData {
    public citeType;
    public title;
    public creator;
    public frbrGroupId;
    public recordId;
    public record: PrimoResponse.IExtendedDoc;

    constructor(citeType, title, creator, frbrGroupId, recordId, record) {
        this.citeType = citeType;
        this.title = decodeURIComponent(title);
        this.creator = decodeURIComponent(creator);
        this.frbrGroupId = frbrGroupId;
        this.recordId = recordId;
        this.record = record;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/citationTrails/citationTrailsBreadcrumbs.directive.ts